module.exports = __webpack_public_path__ + "64340af14b0445c27ead926303028753.svg";